export * from './cachestore';
export * from './syncstore';
export * from './datastore';
export * from './networkstore';
export * from './operations';
export * from './persisters';
export * from './processors';
export * from './repositories';
export * from './sync';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/index.js